/**
 * 4.3AppStore - Main Entry Point
 * 
 * React 16.x with class components for Chrome 68 compatibility
 * NO HOOKS - Uses lifecycle methods only
 */

// Legacy polyfills MUST load before React/other imports (BB10 / old WebKit).
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './polyfills/fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/App.css';

function boot() {
    ReactDOM.render(
        React.createElement(App),
        document.getElementById('root'),
        function() {
            try { window.__bb_app_booted = true; } catch (e) {}
        }
    );
}

try {
    boot();
} catch (e) {
    try { window.__bb_app_boot_error = String(e && (e.stack || e.message) || e); } catch (e2) {}
    try {
        var root = document.getElementById('root');
        if (root) {
            root.innerHTML = '<div style="padding:12px;font-family:sans-serif">This browser could not start the full app. <a href="legacy.html">Open legacy mode</a>.</div>';
        }
    } catch (e3) {}
    try {
        var base = (window.location && window.location.pathname) ? window.location.pathname : '/';
        if (base.indexOf('/') !== -1) base = base.slice(0, base.lastIndexOf('/') + 1);
        if (!base) base = '/';
        window.location.href = base + 'legacy.html?reason=boot';
    } catch (e4) {}
}
